"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when a function is called with an invalid mandatory parameter
 * @param {string} paramName
 */
class InvalidParamError extends ExtendableError_1.default {
    constructor(paramName, paramValue, reason) {
        super(`invalid ${paramName}${paramValue ? ` :: ${paramValue}` : ''}${reason ? ` because ${reason}` : ''}`);
        this.paramName = paramName;
        this.paramValue = paramValue;
        this.reason = reason;
    }
}
exports.default = InvalidParamError;
